export const callPhoneNumberMutator = async (state, payload) => {
  state.callPhoneNumberState = payload
}

export const dialPadStatusMutator = async (state, payload) => {
  state.dialPadStatusState = !state.dialPadStatusState
}
